import * as React from "react";
import Marquee from "react-marquee-slider";
import styles from "./styles.module.scss";
import { MemoMessageModal as MessageModal } from "../../modals/MessageModal";
import Dialog from "../../Dialog";
import { useQuery } from "@apollo/client";
import {
  EventBySlugQuery,
  GetApprovedMessagesQuery,
  GetApprovedMessagesQueryVariables,
} from "@src/@types/api.d";
import { GetApprovedMessages } from "@src/graphql/queries";
import { getCookie } from "cookies-next";
import Icon from "@src/components/Icon";

type Props = {
  eventId: number;
  slugData: EventBySlugQuery | undefined;
};

const MarqueeComp: React.FC<Props> = ({ slugData, eventId }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [show, setShow] = React.useState<boolean>(false);
  const currentAccessToken = getCookie("tsl") as string;
  const [isMarqueePaused, setIsMarqueePaused] = React.useState(false);

  const pauseMarquee = () => setIsMarqueePaused(true);
  const resumeMarquee = () => setIsMarqueePaused(false);

  React.useEffect(() => {
    setShow(true);
  }, []);

  const { data: getApprovedMessagesData } = useQuery<
    GetApprovedMessagesQuery,
    GetApprovedMessagesQueryVariables
  >(GetApprovedMessages, {
    skip: !eventId,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { eventId },
    pollInterval: 1000 * 60,
  });

  return !!getApprovedMessagesData?.getApprovedMessages &&
    getApprovedMessagesData?.getApprovedMessages.length > 0 ? (
    <section className="py-2  bg-[#60535A]">
      <div>
        <div
          className={styles["home__marquee"]}
          onMouseEnter={pauseMarquee}
          onMouseLeave={resumeMarquee}
          onClick={pauseMarquee}
        >
          {/* First Marquee Row */}
          <div style={{ height: "250px", maxWidth: "100vw", width: "100%" }}>
            <Marquee
              velocity={isMarqueePaused ? 0 : 40}
              direction="rtl"
              scatterRandomly={false}
              resetAfterTries={200}
              onInit={() => null}
              onFinish={() => null}
            >
              {getApprovedMessagesData.getApprovedMessages
                .filter((_, i) => i % 2 === 0)
                .map((item, index) => (
                  <div
                    key={`quotes-${index}`}
                    className={styles["home__special-note-box"]}
                  >
                    <p
                      className={`${styles["home__special-note-text"]} font-ebGaramond`}
                    >
                      {item?.content ?? ""}
                    </p>
                  </div>
                ))}
            </Marquee>
          </div>

          {/* Second Marquee Row */}
          {getApprovedMessagesData.getApprovedMessages.length > 1 && (
            <div style={{ height: "250px", maxWidth: "100vw", width: "100%" }}>
              <Marquee
                velocity={isMarqueePaused ? 0 : 40}
                direction="rtl"
                scatterRandomly={false}
                resetAfterTries={200}
                onInit={() => null}
                onFinish={() => null}
              >
                {getApprovedMessagesData.getApprovedMessages
                  .filter((_, i) => i % 2 !== 0)
                  .map((item, index) => (
                    <div
                      key={`quotes-2-${index}`}
                      className={styles["home__special-note-box"]}
                    >
                      <p
                        className={`${styles["home__special-note-text"]} font-ebGaramond`}
                      >
                        {item?.content ?? ""}
                      </p>
                    </div>
                  ))}
              </Marquee>
            </div>
          )}

          {/* Special Note Button */}
          {show && !!currentAccessToken && (
            <div>
              <Dialog
                trigger={
                  <div
                    className={`${styles["home__special-note__btn"]} font-neue`}
                  >
                    Drop a special note
                  </div>
                }
                open={open}
                onOpenChange={setOpen}
              >
                <MessageModal
                  name={slugData?.eventBySlug?.name ?? ""}
                  eventId={eventId}
                  setOpen={setOpen}
                />
              </Dialog>
            </div>
          )}
          {/* <div className="">
            <Dialog
              trigger={
                <button className="border border-white text-white px-6 py-2 text-sm tracking-wider font-ebGaramond hover:bg-white hover:text-[#60535A] transition-colors duration-300 rounded-2xl">
                  CONTINUE READING
                </button>
              }
              open={open}
              onOpenChange={setOpen}
            >
              <MessageModal
                name={slugData?.eventBySlug?.name ?? ""}
                eventId={eventId}
                setOpen={setOpen}
              />
            </Dialog>
          </div> */}
        </div>
      </div>
    </section>
  ) : null;
};

export default MarqueeComp;
